"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadFile = exports.cancelRun = exports.submitToolOutput = exports.runThread = exports.createAndRunThread = exports.completions = exports.getEmbeddings = void 0;
const getEmbeddings = (caller) => (options) => caller('/v1/openai/v1/embeddings').post(options, { headers: { 'x-source': 'reporting-summarise' } });
exports.getEmbeddings = getEmbeddings;
const completions = (caller) => (options) => caller('/v1/openai/v1/chat/completions').post(options, { headers: { 'x-source': 'reporting-summarise' } });
exports.completions = completions;
// TODO: remove harcoded x-source
const createAndRunThread = (caller) => (payload) => caller('/v1/openai/v1/threads/runs').post(payload, {
    headers: { 'x-source': 'reporting-copilot', 'OpenAI-Beta': 'assistants=v2' },
    withResponse: true,
});
exports.createAndRunThread = createAndRunThread;
const runThread = (caller) => ({ threadId, ...payload }) => caller(`/v1/openai/v1/threads/${threadId}/runs`).post(payload, {
    headers: { 'x-source': 'reporting-copilot', 'OpenAI-Beta': 'assistants=v2' },
    withResponse: true,
});
exports.runThread = runThread;
const submitToolOutput = (caller) => ({ threadId, runId, ...payload }) => caller(`/v1/openai/v1/threads/${threadId}/runs/${runId}/submit_tool_outputs`).post(payload, {
    headers: { 'x-source': 'reporting-copilot', 'OpenAI-Beta': 'assistants=v2' },
    withResponse: true,
});
exports.submitToolOutput = submitToolOutput;
const cancelRun = (caller) => ({ threadId, runId }) => caller(`/v1/openai/v1/threads/${threadId}/runs/${runId}/cancel`).post(undefined, {
    headers: { 'x-source': 'reporting-copilot', 'OpenAI-Beta': 'assistants=v2' },
    withResponse: true,
});
exports.cancelRun = cancelRun;
const uploadFile = (caller) => (payload) => {
    const formData = new FormData();
    formData.append('file', payload.file);
    formData.append('purpose', payload.purpose);
    return caller('/v1/openai/v1/files').post(formData, {
        headers: {
            'x-source': 'ideas-copilot',
            'OpenAI-Beta': 'assistants=v2',
        },
    });
};
exports.uploadFile = uploadFile;
//# sourceMappingURL=api.js.map